import React from "react";
import {Button, Popconfirm} from "antd";
import {useTranslation} from "react-i18next";
import {DeleteOutlined} from "@ant-design/icons";
import {useStore} from "../../../../../../../hooks/useStore";

export const UnassignUserGroupButton = ({userId, userGroupKey, recall = () => {}}) => {
    const stores = useStore();
    const {t} = useTranslation(["userAuthorization"]);

    return (
        <Popconfirm
            title={t("components.unassignUserGroupButton.title", {ns: "userAuthorization"})}
            onConfirm={async () => {
                const unassignUserGroupResult = await stores.userStore.unassignUserGroup({
                    userId,
                    userGroupKey
                });
                if (!unassignUserGroupResult.success) return;
                recall();
            }}
            okText={t("modal.yesButton", {ns: "common"})}
            cancelText={t("modal.noButton", {ns: "common"})}
            placement="left"
        >
            <Button
                data-testid="unassignUserGroupButton"
                disabled={false}
                loading={false}
                icon={<DeleteOutlined />}
                onClick={e => e.stopPropagation()}
            ></Button>
        </Popconfirm>
    );
};
